 <template>
  <div class="c-restrictiveIconComponent tooltip-multiline tooltip-bottom-right" :data-tooltip="'Assine um plano CoteiBem para desbloquear este recurso.'">
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" v-bind:svg-inline="''" v-bind:class="'c-restrictiveIconComponent_icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><clipPath id="a"><path data-name="Retângulo 1265" fill="rgba(61,61,61,0.75)" d="M0 0h12v15H0z"/></clipPath></defs><g data-name="Grupo 4727"><g data-name="Grupo 4726" clip-path="url(#a)" fill="rgba(61,61,61,0.75)"><path data-name="Caminho 4015" d="M9.75 15h-7.5A2.252 2.252 0 010 12.75v-4.5A2.252 2.252 0 012.25 6h7.5A2.253 2.253 0 0112 8.25v4.5A2.253 2.253 0 019.75 15m-7.5-7.5a.751.751 0 00-.75.75v4.5a.751.751 0 00.75.75h7.5a.75.75 0 00.749-.75v-4.5a.75.75 0 00-.749-.75z"/><path data-name="Caminho 4016" d="M9.75 7.5A.75.75 0 019 6.75V4.5a2.977 2.977 0 00-.878-2.121 3.072 3.072 0 00-4.243 0A2.982 2.982 0 003 4.5v2.25a.75.75 0 11-1.5 0V4.5a4.5 4.5 0 019 0v2.25a.75.75 0 01-.75.75"/><path data-name="Caminho 4017" d="M6.001 11.812a1.313 1.313 0 010-2.625z"/><path data-name="Caminho 4018" d="M6 11.812V9.187a1.313 1.313 0 010 2.625"/></g></g></svg>

  </div>
</template>

<script lang="ts">
import Vue, { PropOptions } from 'vue'
import { mapState, mapActions } from 'vuex'
import { StoreState } from 'Types'
import { landingSupplier } from 'routes'

const initialState = () => ({
  landingSupplier
})

export default Vue.extend({
  data() {
    return initialState()
  },

  props: {
    text: String
  },

  computed: {
    ...mapState({})
  },

  methods: {}
})
</script>

<style lang="scss">
@import "~css/_references";

.c-restrictiveIconComponent {
  margin-left: 12px;

  &_icon {
   g {fill: $v-colorYellow-dark-3 !important;}
  }

}

</style>